import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Form, Spinner } from 'reactstrap';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import toast from 'react-hot-toast';
import { excelGenerate } from '../../Orders/actions/orderActions';

function STExportReport() {
  const dispatch = useDispatch();
  const { afterToday, combine, allowedMaxDays } = DateRangePicker;

  const [startDate, setStartDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [endDate, setEndDate]     = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [excelExportReport, setExcelExportReport] = useState(false);

  const { country = [] } = useSelector((state) => state.country);
  const { generateFile = [], generateFileLoading } = useSelector((state) => state.order);

  useEffect(() => {
    setExcelExportReport(false);
    if (generateFile?.code === 100) {
      toast.success(generateFile?.message, {
        style: { border: '1px solid #fff', padding: '20px', color: '#ffffff', background: '#4CAF50' },
        iconTheme: { primary: '#FFFAEE', secondary: '#4CAF50' },
      });
    } else if (generateFile?.message) {
      toast.error(generateFile?.message, {
        style: { border: '1px solid #fff', padding: '20px', color: '#ffffff', background: '#f44336' },
        iconTheme: { primary: '#FFFAEE', secondary: '#f44336' },
      });
    }
  }, [generateFile]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setExcelExportReport(true);
    excelGenerate({
      params: {
        export_type: 'marketplace_st_items',
        date_from: startDate,
        date_to: endDate || startDate,
        country,
      },
      dispatch,
    });
  };

  return (
    <Col xl={6} style={{ marginBottom: '20px' }}>
      <Row className="align-items-end">
        <Form onSubmit={handleSubmit}>
          <Col xl={12} className="textAlignRigh">
            <div className="DashbordFliter">
              <div className="InputBg">
                <DateRangePicker
                  placement="leftStart"
                  placeholder="Select Date Range"
                  onClean={() => {
                    setStartDate(moment(new Date()).format('YYYY-MM-DD'));
                    setEndDate(moment(new Date()).format('YYYY-MM-DD'));
                  }}
                  disabledDate={combine(allowedMaxDays(30), afterToday())}
                  onChange={(selectedDates) => {
                    if (selectedDates?.[0]) setStartDate(moment(selectedDates[0]).format('YYYY-MM-DD'));
                    if (selectedDates?.[1]) setEndDate(moment(selectedDates[1]).format('YYYY-MM-DD'));
                  }}
                />
              </div>
              <button type="submit" className="btn btn-dark" style={{ display: 'flex' }}>
                {excelExportReport && (
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                )}{' '}
                Export <i className="bx bx-download" style={{ padding: '3px' }}></i>
              </button>
            </div>
          </Col>
        </Form>
      </Row>
    </Col>
  );
}

export default STExportReport;
